// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-head-cls.liquid so the browser can cache it. Code unchanged.
  (function(){
    function h(s){var x=2166136261;for(var i=0;i<s.length;i++){x^=s.charCodeAt(i);x=Math.imul(x,16777619);}return x>>>0;}
    /* same order as sortGrid in snippets/adore-grid-style.liquid (in stock first, shuffled once a day) */
    window.__adoreSortGrid=function(){
      try{
        var g=document.getElementById('CollectionProductGrid');
        if(!g||g.getAttribute('data-adore-sorted'))return;
        g.setAttribute('data-adore-sorted','1');
        var cols=[].filter.call(g.children,function(c){return c.querySelector('.product-collection');});
        if(cols.length<2)return;
        var keep=/[?&]sort_by=/.test(location.search), day=String(Math.floor(Date.now()/864e5));
        var items=cols.map(function(c,i){
          var allOut=!!c.querySelector('[data-availability="false"]');
          var sizeOut=!!c.querySelector('.adore-card__out');
          var a=c.querySelector('a[href*="/products/"]'), key=(a?a.getAttribute('href').split('?')[0]:String(i))+day;
          return {c:c,tier:allOut?2:(sizeOut?1:0),r:keep?i:h(key),i:i};
        });
        items.sort(function(x,y){return x.tier-y.tier||(x.tier===0?x.r-y.r:x.i-y.i);});
        items.forEach(function(it){g.appendChild(it.c);});
      }catch(e){}
    };
    /* move the title and description into #CollectionHeadingTop now, as the theme's renderCollectionPageHeadings
       would later, then clamp the description on phones (same rule as adore-grid-style) */
    window.__adoreEarlyHeading=function(){
      try{
        var top=document.getElementById('CollectionHeadingTop'); if(!top)return;
        [].forEach.call(document.querySelectorAll('.collection-page-heading-template--position-container,.collection-page-heading-template--position-fullwidth'),function(el){
          if(el.content)return;
          while(el.firstChild)top.appendChild(el.firstChild);
        });
        if(window.innerWidth>767)return;
        var d=top.querySelector('.collection-description-top'); if(!d||d.getAttribute('data-adore-rm'))return;
        var lh=parseFloat(getComputedStyle(d).lineHeight)||22;
        d.setAttribute('data-adore-rm','1');
        if(d.scrollHeight<=lh*5)return;
        d.classList.add('adore-clamp');
        var b=document.createElement('button'); b.type='button'; b.className='adore-readmore'; b.textContent='Read more';
        b.addEventListener('click',function(){ var open=d.classList.toggle('adore-clamp'); b.textContent=open?'Read more':'Show less'; });
        d.parentNode.insertBefore(b,d.nextSibling);
      }catch(e){}
    };
  })();
